<div class="p-4 md:p-6 max-w-full mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">currency_exchange</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Tasa de negociación Zelle</h1>
  </div>

  <!-- Card Tasa Actual -->
  <div *ngIf="tasa" class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">show_chart</mat-icon>
        Tasa Actual
      </h2>
    </div>
    <div class="p-5">
      <app-zelle-change [zelle_buy_rate]="zelleSellValue" [zelle_sell_rate]="zelleBuyValue" [invert]="true" class="zelleChange"></app-zelle-change>
      <div class="flex justify-end mt-4">
        <button type="button" (click)="setRates()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">update</mat-icon>
          Actualizar tasas
        </button>
      </div>
    </div>
  </div>

  <!-- Card Historial -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 16px 24px; border-bottom: 2px solid #93c5fd;">
      <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a5f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1e3a5f;">history</mat-icon>
          Historial de la tasa de negociación
        </h2>
        <button type="button" (click)="reload()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">refresh</mat-icon>
          Refrescar
        </button>
      </div>
    </div>

    <!-- Paginator -->
    <div class="p-4">
      <mat-paginator #paginator
        (page)="onPageChange($event)"
        [length]="totalItems"
        [pageSize]="pageSize"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [pageIndex]="currentPage-1"
        aria-label="Select page">
      </mat-paginator>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto">
      <table mat-table [dataSource]="dataSource" class="w-full" *ngIf="dataSource">
        <!-- Fecha -->
        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef style="min-width: 120px;">Fecha</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.createdAt | date:'dd/MM/yyyy' }}</td>
        </ng-container>

        <!-- Hora -->
        <ng-container matColumnDef="hora">
          <th mat-header-cell *matHeaderCellDef style="min-width: 100px;">Hora</th>
          <td mat-cell *matCellDef="let row" class="text-xs">{{ row.createdAt | date:'hh:mm a' }}</td>
        </ng-container>

        <!-- Tasa USDT -->
        <ng-container matColumnDef="tasa">
          <th mat-header-cell *matHeaderCellDef style="min-width: 180px;">Tasa de Negociación USDT</th>
          <td mat-cell *matCellDef="let row" style="font-weight: 700; color: #1e5a3f; font-size: 0.8rem;">
            {{ row.tasaUsdtClp ? (row.tasaUsdtClp | number:'1.2-2') : '' }}
          </td>
        </ng-container>

        <!-- Tasa Zelle -->
        <ng-container matColumnDef="tasa conv">
          <th mat-header-cell *matHeaderCellDef style="min-width: 200px;">Tasa de Negociación con Zelle</th>
          <td mat-cell *matCellDef="let row" style="font-weight: 700; color: #1e5a3f; font-size: 0.8rem;">
            {{ row.tasaUsdtClp ? (row.tasaUsdtClp * porCompZelle | number:'1.2-2') : '' }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden p-4 space-y-3" *ngIf="dataSource">
      <div *ngFor="let row of dataSource.data; let i = index"
        class="bg-white rounded-xl border border-gray-200 p-4">
        <div class="grid grid-cols-2 gap-3 text-sm">
          <div>
            <span class="text-gray-400 text-xs font-semibold uppercase">Fecha</span>
            <p class="text-gray-800 font-medium mt-0.5">{{ row.createdAt | date:'dd/MM/yyyy' }}</p>
          </div>
          <div>
            <span class="text-gray-400 text-xs font-semibold uppercase">Hora</span>
            <p class="text-gray-800 font-medium mt-0.5">{{ row.createdAt | date:'hh:mm a' }}</p>
          </div>
          <div>
            <span class="text-gray-400 text-xs font-semibold uppercase">Tasa USDT</span>
            <p style="font-weight: 700; color: #1e5a3f; margin-top: 2px;">{{ row.tasaUsdtClp ? (row.tasaUsdtClp | number:'1.2-2') : '' }}</p>
          </div>
          <div>
            <span class="text-gray-400 text-xs font-semibold uppercase">Tasa Zelle</span>
            <p style="font-weight: 700; color: #1e5a3f; margin-top: 2px;">{{ row.tasaUsdtClp ? (row.tasaUsdtClp * porCompZelle | number:'1.2-2') : '' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
